import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import type { UserPanelBaseProps } from "../types";
import { columns } from "./table-config";

export function UserRiskAssessments({ userId }: UserPanelBaseProps) {
	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["users", userId, "risk-assessment-acknowledgements"],
		queryFn: async () => {
			const response = await client.users[":userId"]["risk-assessments"].acknowledgements.$get({
				param: { userId },
			});
			const data = await responseHandler(response);
			return guardArray(data.acknowledgements);
		},
	});

	/** Render */
	return (
		<DataTable
			data={guardArray(data)}
			columns={columns}
			persistenceKey="user-risk-assessments-table"
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			menu={null}
		/>
	);
}
